import Tone from 'tone';

const TIME_16N = new Tone.Time('16n');
export default superclass => class extends superclass  {
    setupSlide() {
        this.slideEnvelope = new Tone.ScaledEnvelope({
            attack: 0.1,
            decay: 0.0001,
            sustain: 1,
            release: 0.00001,
            curve: "linear"});
        this.slideEnvelope._releaseCurve = "linear";
        this.slideEnvelope.connect(this.detuneSignal);
    }

    triggerSlide(transpose, time, duration, isSlide=true) {
        // convert duration into seconds

        let min = 0;
        let max = 0;
        let lastTranspose = this.lastTranspose !== undefined ? this.lastTranspose : transpose;
        if (!isSlide) {
        } else if (this.lastSlideTranspose !== undefined) {
            min = this.lastSlideMax;
            max = (transpose - lastTranspose) * 100;
        } else  {
            max = (transpose - lastTranspose) * 100;
        }
        this.slideEnvelope.min = min;
        this.slideEnvelope.max  = max;
        let dur = duration;
        this.slideEnvelope.attack = dur;
        this.slideEnvelope.triggerAttack(time);
        if (isSlide) {
            this.lastSlideMax = max; // (transpose - lastTranspose) * 100;
            this.lastSlideTranspose = transpose; // (transpose - lastTranspose) * 100;
        }
    }

    releaseSlide(time) {
        this.slideEnvelope.min = 0;
        this.slideEnvelope.triggerRelease(time ? Math.max(0, time - 0.0001) : undefined);
    }

    clearSlide() {
        this.lastSlideTranspose = undefined;
        this.lastSlideMax = undefined;
        // this.slideEnvelope.cancel();
        this.releaseSlide(Tone.Master.context.currentTime + 0.01);
    }
}
